import { type ComponentPropsWithoutRef, memo } from 'react';

import { CommandLoading } from '@air/cmdk';
import { cn } from '@air/utils-tailwind';

export type ComboboxLoadingProps = ComponentPropsWithoutRef<typeof CommandLoading>;

export const ComboboxLoading = memo(({ className, ...restOfProps }: ComboboxLoadingProps) => {
  return (
    <CommandLoading
      className={cn('p-2 text-center ads:text-secondary text-14 text-gray-11', className)}
      data-testid="COMBOBOX_LOADING"
      {...restOfProps}
    />
  );
});

ComboboxLoading.displayName = 'ComboboxLoading';
